import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {FinancingMoney} from '../../types/FinancingMoney';
import {areMoneyValuesEqual} from './areMoneyValuesEqual';

/**
 * Stores a money field as an override only when it differs from the template. An amount equal to
 * the template becomes `null`, so the field keeps following the template.
 */
export function resolveMoneyOverride(
  value: FinancingMoney,
  templateValue: FinancingMoney | Nullish
) {
  return isNotNil(templateValue) && areMoneyValuesEqual(value, templateValue) ? null : value;
}
